exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "ol[data-v-e26fca1e]{margin:0;padding:15px;background:#fff;border-radius:5px}ol>li[data-v-e26fca1e]{list-style:initial;list-style-type:decimal;margin-left:15px}pre[class*=language-][data-v-e26fca1e]{background-color:#fff;border-radius:5px;padding-top:0;padding-bottom:0}.request__controls .delete[data-v-e26fca1e]{fill:#fd77a4;opacity:.6;-webkit-transition:opacity .3s;transition:opacity .3s}.request__controls .delete[data-v-e26fca1e]:hover{opacity:1}", ""]);

// exports
